import React from 'react';
import { rowNoteParts } from './importRowDisplay.js';

/**
 * What a staged row's note says, under its merchant. For an Amazon charge that is the order's items
 * and a link to the order, which is what tells an otherwise anonymous "Amazon" row apart.
 */
export default function ImportRowNotes({ notes }) {
	const { lines, order } = rowNoteParts(notes);
	if(!lines.length && !order) {
		return null;
	}
	return (
		<div className='import-row-notes'>
			{lines.map((line, index) => (
				<div key={index} className='import-external-key' title={line}>{line}</div>
			))}
			{!!order &&
			<a className='import-external-key' href={order.url} target='_blank' rel='noopener noreferrer'>
				Order {order.id}
			</a>
			}
		</div>
	);
}
